import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../features/auth/core/useAuth';

/*
 * The identity provider answers on the root. The auth layer's way on to
 * the returnTo is a react-router transition and arrives after the
 * session does, so a redirect from here would overwrite a deep link.
 */
const isLoginCallback = ({ search }: { search: string }) => {
  const params = new URLSearchParams(search);
  return params.has('code') && params.has('state');
};

/*
 * The root page renders no content of its own (a general dashboard
 * may live here one day): with a valid session it goes straight to
 * the dashboard, without one to the login — which in Keycloak mode
 * immediately forwards to the identity provider.
 */
export const LandingPage = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  /* while the session is being restored (e.g. a token renewal),
     render nothing — redirecting now would be premature */
  if (isLoading) return null;

  /* a failed callback is not signed in and goes to the login, which
     shows the error */
  if (isAuthenticated && isLoginCallback(location)) return null;

  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return <Navigate to="/login" state={{ returnTo: '/dashboard' }} replace />;
};
